import React from "react"
import game from "code-breaker.png"

const CodeBreaker = props => <img src={game} className="game" {...props} />

export default CodeBreaker
